export { getPropsPerDatatestid } from './getPropsPerDatatestid.js';
export { getPropsPerDatatestIdPropTypes } from './getPropsPerDatatestIdPropTypes.js';
